import { fetchSuggestionsByCategory as fetchSuggestionsByCategoryAction } from '../../../../actions/suggestions/suggestions'
import { formatSuggestionsForDisplay } from '../format-suggestion'

/**
 * Kategoriye göre önerileri getirir
 * @param {String} category - İçerik kategorisi
 * @param {Object} params - Ek parametreler
 * @returns {Promise<Object>} Öneri listesi ve sayfalama bilgisi
 */
export const fetchSuggestionsByCategory = async (category, params = {}) => {
  try {
    // API çağrısını yap
    const response = await fetchSuggestionsByCategoryAction(category, params)

    // Cevabı formatla ve döndür
    if (response.code === 200 && response.data) {
      return {
        success: true,
        data: {
          suggestions: formatSuggestionsForDisplay(response.data.data || []),
          pagination: response.data.pagination || {},
        },
      }
    }

    return {
      success: false,
      message: response.message || 'Bir hata oluştu',
      data: { suggestions: [], pagination: {} },
    }
  } catch (error) {
    console.error(`Error fetching suggestions by category ${category}:`, error)
    return {
      success: false,
      message: error.message || 'Öneriler yüklenirken bir hata oluştu',
      data: { suggestions: [], pagination: {} },
    }
  }
}